import kamala from '../../kamala'
import Row from './Row'
import Col from './Col'

const KGrid = {
  install: function (Vue) {
    kamala(Vue)
    Vue.component(Row.name, Row)
    Vue.component(Col.name, Col)
  },
  KRow: Row,
  KCol: Col,
}

export {
  Row,
  Col,
}

export default KGrid
